<template>
  <div class="promos">
    <div class="centered">
      <span class="button-wrapper" @click="handleAddPromo">
        <a class="button is-info rounded">Добавить акцию</a>
      </span>
  </div>
    <div class="promos">
      <promo v-for="promo in currentpromos" :promo="promo" :key="promo.id"/>
    </div>
    <div class="caption">
      <h2>Завершившиеся акции</h2>
      <span>По умолчанию завершившиеся акции не отображаются на сайте</span>
    </div>
    <div class="promos">
      <promo v-for="promo in completedpromos" :promo="promo" :key="promo.id"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Promo from 'components/Promos/Promo'
  import uuidv4 from 'uuid/v4'

  export default {
    name: 'Promos',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['promos']),
      currentpromos () {
        return this.promos.filter(s => !s.completed)
      },
      completedpromos () {
        return this.promos.filter(s => s.completed)
      }
    },
    methods: {
      ...mapActions(['addPromo', 'getPromos']),
      handleAddPromo () {
        this.addPromo({
          'id': uuidv4(),
          'title': '',
          'conditions': '',
          'startDate': new Date(),
          'endDate': new Date(),
          'isHidden': true,
          'publishLater': false,
          'url': '',
          'photo': '',
          'publishDate': new Date(),
          'urlButton': '',
          'service_id': null,
          'completed': '',
          'isNew': true
        })
      }
    },
    created () {
      this.getPromos()
    },
    components: { Promo }
  }
</script>

<style>
.rounded {
  border-radius: 25px !important;
}

.promo .title textarea {
  font-size: 1em;
  min-height: 3em;
}

.trash-icon {
  border: 1px solid red;
  border-radius: 50%;
  padding: 5px;
  width: 40px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Index.vue?411cf96d